import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@static/styles/less/index.less'
import '@static/styles/reset.css'
import '@static/styles/less/public.less'
import '@static/styles/theme/index.less'

import '@static/styles/font.css'

import './iview'
import '@xy/utils/rem.js'

import  '@xy/utils/init'

// 未被捕获的异常处理,处理控制台报错
// import './catchError'
import '@static/styles/iconfont/iconfont.css'

import i18n from '@/lang/index' //国际化

let instance = null
function render(props = {}) {
  const { container } = props
  instance = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}
export async function bootstrap() {
  /* eslint-disable */
  console.log('[vue] vue app bootstraped')
  /* eslint-enable */
}
export async function mount(props) {
  /* eslint-disable */
  console.log('[vue] props from main framework', props)
  /* eslint-enable */
  render(props)
}
export async function unmount() {
  window.__MITO_ = null
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}
